import { DropDownItem } from "../../../forms/forms";
import { CountValueFacetItem, Facet } from "./facet.model";

// this can probably be a dropdown facet to be more generic
export class PrimaryTypeFacet extends Facet {
  // probably dont need the primaryTypes dropdown items, would need to rework show/hide logic of make and model on the sidebar search results
  primaryTypes: DropDownItem[];
  showDropdown: boolean = false;
  selectedPrimaryType: string = "Any";

  constructor(name: string, facets: CountValueFacetItem[]) {
    super(name, facets);

    this.primaryTypes = facets?.map(d => {
      return { label: d.value, value: d.value, subLabel: `(${d.count.toString()})` } as DropDownItem;
    });

    this.showDropdown = facets?.length > 1;
    this.selectedPrimaryType = "Any";
  }

  get selected(): boolean {
    return this.filter() != null;
  }

  uncheck = () => {
    this.selectedPrimaryType = "Any";
    this.facets.forEach(c => (c.checked = false));
  };

  filter(): string {
    const pathSegments = window.location.pathname.split("/").filter(Boolean);
    const equipmentType = decodeURIComponent(pathSegments[1]);
    if (equipmentType == "all") {
      return null;
    }

    return `(${this.name} eq '${equipmentType}')`;
  }

  update = (facets: CountValueFacetItem[]) => {
    if (!facets || facets.length === 0) {
      return;
    }

    // Always update facets and primaryTypes to show all available types
    this.facets = facets;
    this.primaryTypes = facets?.map(d => {
      return { label: d.value, value: d.value, subLabel: `(${d.count.toString()})` } as DropDownItem;
    });
    this.showDropdown = facets?.length > 1;
  };

  toQueryParam = (): string => {
    return undefined;
  };
}
